/* eslint-disable */

import popupTemp from './PopTemple.vue';

const Popup = {
  install: function (Vue) {
    // 1.创建一个Vue的“子类”组件构造器
    const PopupConstructor = Vue.extend(popupTemp)

    // 2.创建一个该子类的实例,并挂载到一个元素上
    const instance = new PopupConstructor()

    // 3.将这个实例挂载到动态创建的元素上,并将元素添加到全局结构中
    instance.$mount(document.createElement('div'))
    //instance.$el对应的就是div
    document.body.appendChild(instance.$el)

    Vue.prototype.$CPopup = (config) => {
      instance.config = config
      instance.visible = true
    }
  }
}

export default Popup
